import {Command} from "./Command";
import {GamePlay} from "../model/game-play";

export class SetYardLineCommand implements Command {
  constructor(
    private gamePlay: GamePlay,
    private yardLine: string
  ) { }

  execute() {
    if (!this.yardLine) {
      throw new Error('SetYardLineCommand sans yardLine')
    }
    this.gamePlay.yardLine = this.yardLine
    console.log('COMMAND SetYardLineCommand', this.yardLine)
  }
}
